import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Shows a toast (shared/toast): natively in apps with the toast component,
// otherwise on the page. Its action stays this element's link or form either
// way: the native toast replies when it's tapped and this follows it, so a
// toast only lives as long as the page that showed it.
export default class extends BridgeComponent {
  static component = "toast"
  static targets = ["action"]
  static values = { message: String, detail: String, actionLabel: String }

  // The page shows the toast itself without native support.
  static get shouldLoad() { return true }

  connect() {
    super.connect()

    if (this.nativeSupported) {
      this.showNatively()
    } else {
      this.showOnPage()
    }
  }

  disconnect() {
    clearTimeout(this.hideTimeout)
    clearTimeout(this.fadeTimeout)
    if (this.shownNatively) this.send("dismiss", { id: this.id })
    super.disconnect()
  }

  // A page coming back into view doesn't bring its toast back.
  restore() {}

  dismiss() {
    clearTimeout(this.hideTimeout)
    this.element.classList.add("opacity-0", "-translate-y-2")
    this.fadeTimeout = setTimeout(() => this.element.classList.add("hidden"), 150)
  }

  // Checked from the user agent, like shouldLoad, since the bridge's own
  // `enabled` is false until the app connects.
  get nativeSupported() {
    const components = navigator.userAgent.match(/bridge-components: \[(.*?)\]/)?.[1].split(" ") ?? []
    return components.includes(this.component) && !this.platformOptingOut
  }

  showNatively() {
    this.id = `${Date.now()}-${Math.random().toString(36).slice(2)}`
    this.shownNatively = true

    const data = {
      id: this.id,
      message: this.messageValue,
      detail: this.detailValue,
      actionLabel: this.hasActionTarget ? this.actionLabelValue : ""
    }

    this.send("show", data, ({ data }) => {
      if (data.action) this.actionTarget.click()
      if (data.dismissed) this.shownNatively = false
    })
  }

  showOnPage() {
    this.element.classList.remove("hidden")
    this.element.offsetHeight // Lay it out hidden first so it transitions in.
    this.element.classList.remove("opacity-0", "-translate-y-2")
    this.hideTimeout = setTimeout(() => this.dismiss(), this.hasActionTarget ? 6000 : 3000)
  }
}
